// byNUT — help popover behaviour:
//  1. Keeps the trigger's aria-expanded in sync with the popover state.
//  2. Positions the popover next to its trigger (native popovers default
//     to the top-left of the viewport with no anchoring set).
//  3. Provides a manual open/close fallback for browsers without the
//     native Popover API (e.g. Safari on iOS 16 and earlier), so the "?"
//     still works there — same visuals, JS-driven instead of native.
(function () {
  if (window.__bynutFilterHelpInit) return;
  window.__bynutFilterHelpInit = true;

  var supportsPopover = 'popover' in HTMLElement.prototype;
  var MARGIN = 8;
  var EDGE = 16;

  function getTrigger(popover) {
    return document.querySelector('[popovertarget="' + popover.id + '"]');
  }

  function positionPopover(trigger, popover) {
    popover.style.visibility = 'hidden';
    popover.style.top = '0px';
    popover.style.left = '0px';

    requestAnimationFrame(function () {
      var triggerRect = trigger.getBoundingClientRect();
      var popRect = popover.getBoundingClientRect();
      var viewportW = document.documentElement.clientWidth;
      var viewportH = document.documentElement.clientHeight;

      var left = triggerRect.left;
      if (left + popRect.width > viewportW - EDGE) {
        left = viewportW - popRect.width - EDGE;
      }
      if (left < EDGE) left = EDGE;

      var top = triggerRect.bottom + MARGIN;
      if (top + popRect.height > viewportH - EDGE) {
        var above = triggerRect.top - popRect.height - MARGIN;
        top = above > EDGE ? above : EDGE;
      }

      popover.style.top = top + 'px';
      popover.style.left = left + 'px';
      popover.style.visibility = 'visible';
    });
  }

  function syncAria(popover, isOpen) {
    var trigger = getTrigger(popover);
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (!isOpen && document.activeElement === document.body) {
      trigger.focus();
    }
  }

  if (supportsPopover) {
    document.addEventListener(
      'toggle',
      function (event) {
        var popover = event.target;
        if (!popover.classList || !popover.classList.contains('filter-help__popover')) return;

        var isOpen = event.newState === 'open';
        syncAria(popover, isOpen);

        if (isOpen) {
          var trigger = getTrigger(popover);
          if (trigger) positionPopover(trigger, popover);
        }
      },
      true
    );
    return;
  }

  // --- Fallback for browsers without the native Popover API ---
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.filter-help__trigger');
    var openPopover = document.querySelector('.filter-help__popover.is-open-fallback');

    if (trigger) {
      var popoverId = trigger.getAttribute('popovertarget');
      var popover = popoverId ? document.getElementById(popoverId) : null;
      if (!popover) return;
      var alreadyOpen = popover.classList.contains('is-open-fallback');

      if (openPopover && openPopover !== popover) {
        openPopover.classList.remove('is-open-fallback');
        syncAria(openPopover, false);
      }

      if (alreadyOpen) {
        popover.classList.remove('is-open-fallback');
        syncAria(popover, false);
      } else {
        popover.classList.add('is-open-fallback');
        syncAria(popover, true);
        positionPopover(trigger, popover);
      }
      return;
    }

    if (openPopover && !event.target.closest('.filter-help__popover')) {
      openPopover.classList.remove('is-open-fallback');
      syncAria(openPopover, false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openPopover = document.querySelector('.filter-help__popover.is-open-fallback');
    if (!openPopover) return;
    openPopover.classList.remove('is-open-fallback');
    syncAria(openPopover, false);
    var trigger = getTrigger(openPopover);
    if (trigger) trigger.focus();
  });
})();
